<template>
  <mediaTemplate1 v-if="!content.templateType || content.templateType === 1" :content="content"></mediaTemplate1>
  <mediaTemplate2 v-else-if="content.templateType === 2" :content="content"></mediaTemplate2>
  <mediaTemplate3 v-else-if="content.templateType === 3" :content="content"></mediaTemplate3>
</template>
<script>
/*
媒体组件
*/
import mediaTemplate1 from "./template/template-1.vue";
import mediaTemplate2 from "./template/template-2.vue";
import mediaTemplate3 from "./template/template-3.vue";

export default {
  name: "mediaIndex",
  components: {
    mediaTemplate1,
    mediaTemplate2,
    mediaTemplate3,
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.content_w_710 {
  width: calc(100% - 48rem);
  margin: 0 auto 20px;
}
</style>